import {
  KPI_MODAL_PARAM,
  KPI_ID_PARAM,
  TEAM_ID_PARAM,
  KPI_LOCATION_PARAM,
  type KPIModalValue,
  type KPILocationValue,
} from '../constants';

interface CheckModalUrlResult {
  isOpen: boolean;
  teamId: string | null;
  kpiId: string | null;
  location: KPILocationValue | null;
}

/**
 * Updates the URL with the given search parameters
 */
const updateUrl = (searchParams: URLSearchParams) => {
  const newSearch = searchParams.toString();
  const newUrl = newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname;

  window.history.replaceState(window.history.state, '', newUrl);
};

/**
 * Checks if the URL contains a specific modal parameter value
 */
export function checkModalUrl(expectedValue: KPIModalValue): CheckModalUrlResult {
  const searchParams = new URLSearchParams(window.location.search);

  const openModalParam = searchParams.get(KPI_MODAL_PARAM);
  const teamIdParam = searchParams.get(TEAM_ID_PARAM);
  const kpiIdParam = searchParams.get(KPI_ID_PARAM);
  // Location parameter is used for the analytics event properties
  const locationParam = searchParams.get(KPI_LOCATION_PARAM);

  return {
    isOpen: (openModalParam as KPIModalValue | null) === expectedValue,
    teamId: teamIdParam ?? null,
    kpiId: kpiIdParam ?? null,
    location: (locationParam as KPILocationValue | null) ?? null,
  };
}

/**
 * Removes the modal parameter from the URL without triggering React Router navigation
 */
export function removeModalFromUrl(): void {
  const searchParams = new URLSearchParams(window.location.search);

  // Not deleting team ID parameter because it can be used for some other logic
  searchParams.delete(KPI_MODAL_PARAM);
  searchParams.delete(KPI_ID_PARAM);
  searchParams.delete(KPI_LOCATION_PARAM);

  updateUrl(searchParams);
}
